module.exports = __webpack_public_path__ + "static/media/RN_vs_NP.a8543b63.webp";